import { render, staticRenderFns } from "./NotifyPatientPositionUpdate.vue?vue&type=template&id=54e732e4&scoped=true&"
import script from "./NotifyPatientPositionUpdate.vue?vue&type=script&lang=js&"
export * from "./NotifyPatientPositionUpdate.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "54e732e4",
  null
  
)

export default component.exports